// extracted by mini-css-extract-plugin
export default {"header":"AppRouter__header--3bT","cookieLayer":"AppRouter__cookieLayer--2_y","content":"AppRouter__content--DEY"};